export default {"src":"/_next/static/media/chatinoo.3fb05da6.svg","height":37,"width":122,"blurWidth":0,"blurHeight":0};